import { render, staticRenderFns } from "./IconCustom.vue?vue&type=template&id=56ed97d2"
import script from "./IconCustom.vue?vue&type=script&lang=js"
export * from "./IconCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports